

    
<div id="imgPreview" style="width:100% ; height: auto">
    <div fxLayout="row" fxLayoutAlign="end center">
        <button (click)="close()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    </div>

    <div *ngIf="data.length==0; else imgMissing" fxLayoutAlign="center center">
    </div>

    <ng-template #imgMissing >
<mat-dialog-content style=" MARGIN: 0PX;  max-height: 100%;
    padding: 0px;" class="mat-typography">

<owl-carousel-o fxLayoutAlign="center center" 
[options]="slideConfig" 
#owlCar  class="product-slick">
  <ng-container *ngFor="let  img of data; let l = index">
      <ng-template carouselSlide>
          <div>

            <ng-container fxLayoutAlign="center center" *ngIf="img.includes('http')">
              
              <img [ngStyle.lt-md]="{height:productDetailHeightMobile,width:productDetailWidthMobile}" 
            class="padding-10 pre" [src]="img | safe: 'resourceUrl'"
              onerror="this.src='assets/images/products/noImage/no-image.png';" alt="productIamge">
         </ng-container>
            <ng-container *ngIf="!img.includes('medicineimages')&&!img.includes('http')&&!img.includes('commonimages')">
              <img [ngStyle.lt-md]="{height:productDetailHeightMobile,width:productDetailWidthMobile}" 
            class="padding-10 pre" [src]="bigImage + img| safe: 'resourceUrl' "
              onerror="this.src='assets/images/products/noImage/no-image.png';" alt="productIamge">
         </ng-container>
         <ng-container *ngIf="img.includes('medicineimages')">
          <img [ngStyle.lt-md]="{height:productDetailHeightMobile,width:productDetailWidthMobile}" 
        class="padding-10 pre"  [src]="commonImageApi + img| safe: 'resourceUrl'"
          onerror="this.src='assets/images/products/noImage/no-image.png';" alt="productIamge">
     </ng-container>

     <ng-container *ngIf="img.includes('commonimages')">
      <img [ngStyle.lt-md]="{height:productDetailHeightMobile,width:productDetailWidthMobile}" 
    class="padding-10 pre"  [src]="serverPath7 + img| safe: 'resourceUrl'"
      onerror="this.src='assets/images/products/noImage/no-image.png';" alt="productIamge">
 </ng-container>
          </div>
      </ng-template>
  </ng-container>
</owl-carousel-o>


       

</mat-dialog-content>
</ng-template>